(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getGap(element) {
    var styles = window.getComputedStyle(element);
    var gap = parseFloat(styles.columnGap || styles.gap || '0');
    return isNaN(gap) ? 0 : gap;
  }

  function getItemsWidth(items, grid) {
    var gap = getGap(grid);
    var total = 0;

    items.forEach(function (item, index) {
      total += item.offsetWidth;
      if (index < items.length - 1) total += gap;
    });

    return total;
  }

  function initAutoCollectionSlider(root) {
    var sliders = (root || document).querySelectorAll('.js-auto-collection-slider[data-autoscroll="true"]');

    sliders.forEach(function (slider) {
      if (slider.dataset.autoscrollInitialized === 'true') return;
      if (prefersReducedMotion()) return;

      var grid = slider.querySelector('.slider__grid');
      if (!grid) return;

      var originalItems = Array.prototype.slice.call(grid.children);
      if (originalItems.length < 2) return;

      slider.dataset.autoscrollInitialized = 'true';

      var speed = parseFloat(slider.dataset.autoscrollSpeed || '1.5');
      var paused = false;
      var rafId = null;
      var loopWidth = 0;
      var offset = 0;
      var lastTime = null;

      function sanitizeClone(clone) {
        clone.setAttribute('aria-hidden', 'true');

        var focusables = clone.querySelectorAll('a, button, input, select, textarea');
        focusables.forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      }

      function buildTrack() {
        // Limpia clones anteriores si Shopify vuelve a renderizar
        var children = Array.prototype.slice.call(grid.children);
        children.forEach(function (child) {
          if (child.hasAttribute('data-clone')) {
            child.remove();
          }
        });

        loopWidth = getItemsWidth(originalItems, grid);

        if (!loopWidth) return;

        // Necesitamos que haya suficiente contenido repetido
        // para cubrir el viewport + un ciclo adicional
        var minTrackWidth = loopWidth + slider.offsetWidth;
        var appendedWidth = 0;

        while (appendedWidth < minTrackWidth) {
          originalItems.forEach(function (item) {
            var clone = item.cloneNode(true);
            clone.setAttribute('data-clone', 'true');
            sanitizeClone(clone);
            grid.appendChild(clone);
          });

          appendedWidth += loopWidth;
        }
      }

      function render() {
        grid.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }

      function step(timestamp) {
        if (lastTime === null) lastTime = timestamp;
        var delta = timestamp - lastTime;
        lastTime = timestamp;

        if (!paused && loopWidth > 0) {
          offset += speed * (delta / 16.6667);

          if (offset >= loopWidth) {
            offset -= loopWidth;
          }

          render();
        }

        rafId = window.requestAnimationFrame(step);
      }

      function pause() {
        paused = true;
        slider.classList.add('is-paused');
      }

      function resume() {
        paused = false;
        slider.classList.remove('is-paused');
      }

      function rebuild() {
        buildTrack();

        if (loopWidth > 0) {
          offset = offset % loopWidth;
        } else {
          offset = 0;
        }

        render();
      }

      window.requestAnimationFrame(function () {
        rebuild();
        rafId = window.requestAnimationFrame(step);
      });

      slider.addEventListener('mouseenter', pause);
      slider.addEventListener('mouseleave', resume);
      slider.addEventListener('focusin', pause);
      slider.addEventListener('focusout', resume);
      slider.addEventListener('touchstart', pause, { passive: true });
      slider.addEventListener('touchend', resume, { passive: true });

      window.addEventListener('resize', function () {
        rebuild();
      });

      document.addEventListener('shopify:section:unload', function () {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAutoCollectionSlider(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAutoCollectionSlider(event.target);
  });
})();